<template>
  <b-modal
    centered
    @show="onShow"
    @hide="onCancel"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    header-class="popup_header1"
    content-class="c-content"
    body-class="c-body container c-body_padding"
    :visible="visible"
    hide-footer
  >
    <template #modal-header="{close}" style="padding-right: 5px;">
      <div class="popup_title" style="flex: 1; text-align: center;">&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('more.usage_extension') }}</div>
      <a class="dlg_close_btn" style="background-color: white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 18px; margin-left: 7px; margin-right: 20px; "/>
      </a>
    </template>
    <div>
      <b-container class="margin-bottom-15" style="padding: 0 5px;">
        <b-row>
          <b-col cols="7" style="padding-left: 10px;">
            <div style="font-size: 16px; font-family: 'KoreanGD17R';">전체 이용권 (기본 알림 포함)</div>
          </b-col>
          <b-col cols="5" style="padding-right: 5px;">
            <div style="text-align: right">
              <span class="point_remain" style="margin-top: 8px; font-size: 14px; font-family: 'KoreanGD17R';text-decoration: underline">
                {{ut.format($t('more.point_remain'), u.currency(self.myinfo.point))}}
              </span>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container style="padding: 0 5px;">
        <b-row>
          <b-col class="col_left">
            <StateButton :key="0"
                         :active="index == 0"
                         :item="USAGE_LIST[0]"
                         @onPress="() => {u.setState(self,{index: 0})}" />
          </b-col>
          <b-col class="col_right">
            <StateButton :key="1"
                         :active="index == 1"
                         :item="USAGE_LIST[1]"
                         @onPress="() => {u.setState(self,{index: 1})}" />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col_left">
            <StateButton :key="2"
                         :active="index == 2"
                         :item="USAGE_LIST[2]"
                         @onPress="() => {u.setState(self,{index: 2})}" />
          </b-col>
          <b-col class="col_right">
            <StateButton :key="3"
                         :active="index == 3"
                         :item="USAGE_LIST[3]"
                         @onPress="() => {u.setState(self,{index: 3})}" />
          </b-col>
        </b-row>
      </b-container>

      <b-container class="margin-bottom-15 margin-top-15" style="padding: 0 5px;">
        <b-row>
          <b-col cols="5" style="padding-left: 10px;">
            <div style="font-size: 16px; font-family: 'KoreanGD17R';">알림 추가 기능</div>
          </b-col>
          <b-col cols="7" style="padding-right: 5px;">
            <div style="text-align: right">
              <span class="point_remain" style="margin-top: 8px; font-size: 14px; font-family: 'KoreanGD17R';text-decoration: underline">
                {{ut.format($t('more.made_remain_gae'), u.currency(self.myinfo.madeCnt))}},
              </span>              
              <span class="point_remain" style="margin-top: 8px; font-size: 14px; font-family: 'KoreanGD17R';text-decoration: underline">
                {{ut.format($t('more.push_remain_gae'), u.currency(self.myinfo.pushCnt))}}
              </span>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <b-container style="padding: 0 5px;">
        <b-row>
          <b-col></b-col>
          <b-col><span class="alarm_label radius_label" :class="{'btn_active' : (getSelectedItem().made == 5 || getSelectedItem().push == 5)}">추가 없음</span></b-col>
          <b-col><span class="alarm_label radius_label" :class="{'btn_active' : (getSelectedItem().made == 13 || getSelectedItem().push == 13)}">30% 추가</span></b-col>
          <b-col><span class="alarm_label radius_label" :class="{'btn_active' : (getSelectedItem().made == 30 || getSelectedItem().push == 30)}">50% 추가</span></b-col>
        </b-row>
        <b-row>
          <b-col><span class="alarm_label margin-top-15" :class="{'btn_active' : (getSelectedItem().made > 0 && getSelectedItem().push == 0)}">메이드+</span></b-col>
          <b-col>
            <StateButton :key="4"
                              :active="index == 4"
                              :item="USAGE_LIST[4]"
                              @onPress="() => {u.setState(self,{index: 4})}" />
          </b-col>
          <b-col>
            <StateButton :key="5"
                         :active="index == 5"
                         :item="USAGE_LIST[5]"
                         @onPress="() => {u.setState(self,{index: 5})}" />
          </b-col>
          <b-col>
            <StateButton :key="6"
                         :active="index == 6"
                         :item="USAGE_LIST[6]"
                         @onPress="() => {u.setState(self,{index: 6})}" />
          </b-col>
        </b-row>
        <b-row>
          <b-col><span class="alarm_label margin-top-15" :class="{'btn_active' : (getSelectedItem().made == 0 && getSelectedItem().push > 0)}">PUSH</span></b-col>
          <b-col>
            <StateButton :key="7"
                         :active="index == 7"
                         :item="USAGE_LIST[7]"
                         @onPress="() => {u.setState(self,{index: 7})}" />
          </b-col>
          <b-col>
            <StateButton :key="8"
                         :active="index == 8"
                         :item="USAGE_LIST[8]"
                         @onPress="() => {u.setState(self,{index: 8})}" />
          </b-col>
          <b-col>
            <StateButton :key="9"
                         :active="index == 9"
                         :item="USAGE_LIST[9]"
                         @onPress="() => {u.setState(self,{index: 9})}" />
          </b-col>
        </b-row>
        <b-row class="margin-top-10">
          <b-col style="text-align: right">
            <span class="alarm_label radius_label" style="width: 205px; max-width: 205px; text-align: center; margin-right: 6px"
                  :class="{'btn_active' : (getSelectedItem().made > 10 && getSelectedItem().push > 10)}">30일 이용권 제공</span>
          </b-col>
        </b-row>
        <b-row class="margin-bottom-20">
          <b-col style="margin-top: -5px">
            <span class="alarm_label margin-top-5" style="margin-bottom: 3px" :class="{'btn_active' : (getSelectedItem().made > 0 && getSelectedItem().push > 0)}">메이드+</span>
            <span class="alarm_label" style="margin-bottom: 0" :class="{'btn_active' : (getSelectedItem().made > 0 && getSelectedItem().push > 0)}">PUSH</span>
          </b-col>
          <b-col>
            <StateButton :key="10"
                         :active="index == 10"
                         :item="USAGE_LIST[10]"
                         @onPress="() => {u.setState(self,{index: 10})}" />
          </b-col>
          <b-col>
            <StateButton :key="11"
                         :active="index == 11"
                         :item="USAGE_LIST[11]"
                         @onPress="() => {u.setState(self,{index: 11})}" />
          </b-col>
          <b-col>
            <StateButton :key="12"
                         :active="index == 12"
                         :item="USAGE_LIST[12]"
                         @onPress="() => {u.setState(self,{index: 12})}" />
          </b-col>
        </b-row>
      </b-container>

      <div class="flex_1 align-vertical">
        <div class="divider1" />
        <div class="align-horizontal footer" style="margin-top: 10px;">
          <div class="align-vertical flex_1 ml-4">
            <span class="total_pay">{{$t('more.payment_point')}}</span>
            <span class="charge_cost">{{ut.format($t('more.point'), u.currency(USAGE_LIST[index].point))}}</span>
          </div>
          <b-button class="charge_btn charge_btn_text" @click="onCharge">
            {{$t('more.purchase')}}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
import StateButton from "../StateButton";
import moment from "moment";
const utils = require('util');
const USAGE_LIST = [
  {
    day: 30,
    point: 12000,
    percent: 0,
    made: 0,
    push: 0
  },
  {
    day: 90,
    point: 30000,
    percent: 17,
    made: 0,
    push: 0
  },
  {
    day: 180,
    point: 55000,
    percent: 24,
    made: 0,
    push: 0
  },
  {
    day: 365,
    point: 99000,
    percent: 31,
    made: 0,
    push: 0
  },
  {
    day: 0,
    point: 10000,
    percent: 0,
    made: 5,
    push: 0
  },
  {
    day: 0,
    point: 20000,
    percent: 0,
    made: 13,
    push: 0
  },
  {
    day: 0,
    point: 40000,
    percent: 0,
    made: 30,
    push: 0
  },
  {
    day: 0,
    point: 10000,
    percent: 0,
    made: 0,
    push: 5
  },
  {
    day: 0,
    point: 20000,
    percent: 0,
    made: 0,
    push: 13
  },
  {
    day: 0,
    point: 40000,
    percent: 0,
    made: 0,
    push: 30
  },
  {
    day: 0,
    point: 20000,
    percent: 0,
    made: 5,
    push: 5
  },
  {
    day: 30,
    point: 40000,
    percent: 0,
    made: 13,
    push: 13
  },
  {
    day: 30,
    point: 80000,
    percent: 0,
    made: 30,
    push: 30
  }
];
export default {
  name: "UsageExtendPopup",
  components: {StateButton},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    showPointCharge:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: utils,
      USAGE_LIST: USAGE_LIST,
      index: 0,
      showChargePointPopup: false,
      showLoading: false
    }
  },
  mounted() {

  },
  inject: ['eventBus'],
  methods:{

    onShow() {
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
      this.index = 0;
    },
    onCancel()  {
      if(window.history.state == "forward")
        window.history.back();
    },
    onCharge () {
      let {index} = this;
      let usage_info = USAGE_LIST[index];

      if (usage_info.point > this.myinfo.point) {
        Utils.showConfirm(this, '<p style="font-size: 1.1em;">'+this.$t('more.point_not_enough')+'</p>'+
          '<p style="color: #cf0000; text-decoration: underline; margin-bottom: 0">'+ this.$t('more.point_purchase') +'</p>').then(value => {
            if (value) {
              // Utils.setState(this,{
              //   showChargePointPopup: true
              // });
              console.log("---goto point charge popup ----")
              this.$emit('update:showPointCharge', true);
            }
        })
        return;
      }
      this.showLoading = true;
      Utils.requestPost(
        this.$c.API.Purchase.buyPeriod,
        {
          period: Math.floor(usage_info.day / 30),
          made: usage_info.made,
          push: usage_info.push
        },
      ).then(async result => {
        this.showLoading = false;
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          await this.getProfile();
          Utils.toast(this, this.$t('more.usage_success'));
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },
    getSelectedItem() {
      return this.USAGE_LIST[this.index];
    },
    async getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(async result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          await this.myinfo.saveInfo();
          await this.myinfo.loadInfo();
          console.log("---getProfile-----")
          this.$emit('update:visible', false)
          this.$emit('onCharge');
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.point_label {
  align-self: center;
  color: $c_457fff;
  font-size: $fs_11;
  font-family: $korean_gd_17_r;
  margin-top: 30px
}
.point_text {
  align-self: center;
  color: $black;
  font-size: 30px;
  font-family: $korean_gd_17_r;
  font-weight: normal;
  margin-top: 5px
}
.divider {background-color: #f9f9f9; height: 12px; align-self: stretch; margin-right: -15px; margin-left: -15px}
.caption {color: $black; font-size: $fs_15}
.point_remain1 {
  font-size: $fs_20;
  font-family: $korean_gd_15_r;
  color: #7b7b7b;
  align-self: flex-end
}
.point_remain {
  font-size: $fs_20;
  font-family: $korean_gd_15_r;
  color: #7b7b7b;
  align-self: flex-end
}
.divider1 {height: 5px; background-color: #f7f7f7; margin-right: -15px; margin-left: -15px; margin-bottom: 10px;}
footer {height: 99px; align-items: center}
.charge_btn {
  width: 150px;
  height: 54px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background-color: $c_457fff;
  margin-left: 20px;
  margin-right: 10px;
  padding-left: 15px;
  margin-bottom: 15px;
}
.charge_btn_text {color: $white; font-size: $fs_22; font-family: $korean_gd_15_r; margin-bottom: 7px;}
.total_pay {color: $c_457fff; font-size: $fs_16; font-family: $korean_gd_15_r}
.charge_cost {
  color: $black;
  font-size: $fs_26;
  font-family: $korean_gd_17_r;
  font-weight: normal;
}
.select_info {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 32px;
  height: 150px;
  border:solid 2px #e5e4e1;
  border-radius: 5px;
  justify-content: center;
  padding-left: 23px;
  padding-right: 17px;
}
.badge {
  display: flex;
  width: 80px;
  height: 36px;
  background-color: #e5e4e1;
  border-radius: 2px;
  align-items: center;
  justify-content: center
}
.badge_active {background-color: $trading1}
.badge_text {font-size: $fs_16; font-family: $korean_gd_15_r; color: $white}
.unit_text {font-size: $fs_20; font-family: $korean_gd_15_r; color: #e5e4e1}
.unit_text_active {color: $trading1}
.row { margin-left: -4px; margin-right: -4px; }
.col { padding-left: 4px; padding-right: 4px; justify-content: center; align-items: center; text-align: center; vertical-align: middle}
.col_left { padding-left: 4px; padding-right: 6px; justify-content: center; align-items: center; text-align: center; vertical-align: middle}
.col_right { padding-left: 6px; padding-right: 4px; justify-content: center; align-items: center; text-align: center; vertical-align: middle}
.alarm_label {
  font-size: $fs_16;
  color: white;
  background-color: #e5e4e1;
  font-family: $korean_gd_16_r;
  padding: 2px 6px;
  display: inline-block;
  margin-bottom: 10px;
  max-width: 110px;
  min-width: 100px;
}
.alarm_label.radius_label {border-radius: 5px}
.alarm_label.btn_active { color: white; background-color: #cf0000; }

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/UsageExtendPopup.vue